let Events = require('f.core.event');
// var WebSocket = require('../mock/websocket');
let createRequestId = require('./requestid');
let Gateway = require('./gateway');

let Message = function(options, errorCallback) {
    this.options = options;
    this.retryCount = options.retryCount || 9999;
    this.pingTime = options.pingTime || 30;
    this.delayTime = options.delayTime || 10;
    this.errorCallback = errorCallback || function() {};
    this.retryTimer = null;
    this.init();
};

Message.prototype = {
    init: function() {
        this.cachs = [];
        this.promises = {};
        this.eventNames = {};
        this.event = new Events();
        this.closeType = 'system';
        this.createWs();
        this.gateway = new Gateway(this);
        this.lastReadyState = '';
    },

    createWs: function() {
        let options = this.options;
        let timer = setTimeout(
            function() {
                this.close(true);
                this.errorCallback('timeout');
                // todo 报告超时错误
            }.bind(this),
            options.timeout || 10000
        );

        let params = {
            roomid: options.roomid,
            source: options.source,
            deviceid: options.deviceid,
            version: options.version,
            app: options.app,
            liveid: options.roomid,
            praise_type: options.praise_type,
            deviceid_real: options.deviceid_real,
            os: options.os,
            gv: options.gv,
            proid: options.proid,
            uid: options.deviceid,
            token: options.token
        };

        // 升级协议，全部为ws
        let socketUrl = 'ws:';
        // let socketPort = location.protocol === 'http:' ? ':9501' : ':9505';
        // 后端升级域名，去端口，为80
        let socketPort = '';
        // 测试用
        if (Number(options.roomid) === 100008) {
            socketPort = '';
        }
        let urlArrays = options.url.split(':');
        if (urlArrays[0]) {
            socketUrl += urlArrays[1] + socketPort;
        }
        let ws = new WebSocket(socketUrl + '?' + $.param(params));

        this.event.trigger('begin');

        let interTime = setInterval(function() {
            ws.send('ping');
        }, this.pingTime * 1000);

        ws.onopen = function() {
            this.retryCount = this.options.retryCount || 9999;
            clearTimeout(timer);
            this.getUser().then(() => {
                this.sendCaches();
            });
            this.event.trigger('open');
            this.lastReadyState = ws.readyState;
        }.bind(this);

        ws.onclose = function() {
            if (this.lastReadyState !== ws.readyState) {
                this.event.trigger('close');
                this.lastReadyState = ws.readyState;
            }
            clearTimeout(timer);
            clearInterval(interTime);

            // 将该次连接所有 message.send 产生的未获得返回的 promise 都触发 reject，告知调用放连接关闭了。
            // 要不要这么做呢 ？？？？ 如果再次连上，服务端能续发，那这里可以不处理，等着就好。
            for (let key in this.promises) {
                this.promises[key].reject({
                    code: 505,
                    message: '连接意外关闭',
                    data: {
                        requestid: key
                    }
                });
            }

            if (this.closeType !== 'system') {
                this.closeType = 'system';
                return;
            }

            if (this.retryCount > 0) {
                this.retryCount--;
                this.retryTimer = setTimeout(
                    function() {
                        this.createWs();
                    }.bind(this),
                    this.delayTime * 1000
                );
            } else {
                this.errorCallback('retry');
                // todo 报告重试错误
            }
        }.bind(this);

        ws.onmessage = function(evt) {
            let msg = evt.data;
            if (msg == 'pong') {
                return;
            }

            if (msg == 'ping') {
                ws.send('pong');
                return;
            }

            try {
                msg = JSON.parse(msg);
                let requestid = msg.data.requestid;

                if (msg.code == 1) {
                    if (this.promises[requestid]) {
                        this.promises[requestid].resolve(msg.data);
                        delete this.promises[requestid];
                    }

                    msg.data.type = msg.type;
                    msg.data.commandid = msg.commandid;
                    this.event.trigger(msg.type + msg.commandid, msg.data);
                } else {
                    if (this.promises[requestid]) {
                        this.promises[requestid].reject(msg);
                        delete this.promises[requestid];
                    }
                }
            } catch (e) {
                // todo 报告数据错误
            }
        }.bind(this);

        ws.onerror = function(e) {
            this.event.trigger('onerror500', {
                commandid: 500
            });
        }.bind(this);

        this.ws = ws;
    },

    send: function(type, commandid, data) {
        data = data || {};
        let requestid = createRequestId();
        let msg = {
            type: type,
            commandid: commandid,
            data: data
        };
        data.requestid = requestid;

        let serializeStr = JSON.stringify(msg);

        let promise = new Promise(
            function(resolve, reject) {
                this.promises[requestid] = {
                    resolve: resolve,
                    reject: reject
                };
            }.bind(this)
        );

        // 为了屏蔽对promise错误没有捕捉的抛错，因为有时候捕捉是在另外一个流程里
        promise.then(function() {}).catch(function() {});

        if (this.ws.readyState == 1) {
            this.ws.send(serializeStr);
        } else {
            this.cachs.push(serializeStr);
        }

        return promise;
    },

    sendCaches: function() {
        let serializeStr;
        while (this.cachs.length > 0) {
            serializeStr = this.cachs.shift();
            this.ws.send(serializeStr);
        }
    },

    on: function(name, commandid, callback) {
        let a = name.split(':');
        let type = a[0];
        let namespace = a[1] || '';
        if (typeof this.eventNames[type] === 'undefined') {
            this.eventNames[type] = {};
        }
        this.eventNames[commandid] = 1;
        this.event.on(type + commandid + ':' + namespace, callback);
    },

    off: function(name, commandid, callback) {
        let a = name.split(':');
        let type = a[0];
        let namespace = a[1] || '';

        if (commandid) {
            this.event.off(type + commandid, callback);
        } else {
            if (this.eventNames[type]) {
                for (let key in this.eventNames[type]) {
                    this.event.off(type + key + ':' + namespace, callback);
                }
            }
        }
    },

    close: function(retry) {
        if (!retry) {
            this.closeType = 'user';
        }
        this.ws.close();
    },

    trytoConnect: function() {
        if (this.ws.readyState != 1) {
            clearTimeout(this.retryTimer);
            this.createWs();
        }
    },
    getUser: function() {
        return this.gateway.getUser();
    }
};

module.exports = Message;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.messageCenter/lib/message.js